module.exports = __webpack_public_path__ + "assets/img/5.06280e2c.png";